import {
  getStartNode,
  type IntermediateNode,
  transformNodeGraphToIntermediateNodeArray
} from 'Automations/nodeDefinitions'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import { isAutomationPresentation } from 'Automations/nodeDefinitions/guards'

export const presentationToNodeTypes = (
  presentation: unknown,
  definitions: ResolvedNodeDefinitions,
  opts?: Partial<{ filterNodeTypes: NodeType[]; filterStartNodes: boolean }>
): NodeType[] => {
  if (!presentation || !isAutomationPresentation(presentation)) {
    return []
  }

  if (!getStartNode(presentation, definitions)) {
    return []
  }

  const intermediateNodes =
    transformNodeGraphToIntermediateNodeArray(definitions)(presentation)

  const flatten = (nodes: IntermediateNode[]): NodeType[] =>
    nodes.flatMap(({ node, branches }) => [
      node.type as NodeType,
      ...branches.flatMap(branch => flatten(branch))
    ])

  const nodeTypes = flatten(intermediateNodes)

  const allowedNodeTypes = nodeTypes.filter(nodeType => {
    if (opts?.filterNodeTypes?.includes(nodeType)) return false

    if (opts?.filterStartNodes) {
      if (definitions[nodeType].startNodeTriggerType) return false
    }

    return true
  })

  return allowedNodeTypes
}
